import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
    isEqual as _isEqual,
    cloneDeep as _cloneDeep,
    get as _get,
} from "lodash";
import { makeStyles } from "@mui/styles";
import { alpha } from '@mui/material/styles';
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import RadioGroup from '@mui/material/RadioGroup';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Radio from '@mui/material/Radio';
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import FrontendConfig from "./frontendconfig";
import { DataGridPro } from '@mui/x-data-grid-pro';
import Auth from "../../../../data/auth-service";
import GCPService from "../../../../data/gcp-service";
import InstanceGroupService from "../../../../data/instancegroup-service";
import LoadBalancerService from "../../../../data/loadbalancer-service";
import Animations from "../../../../libraries/animations";
import { InputLabel, Select, MenuItem } from '@mui/material';
import Validator, {
    useValidate,
} from "../../../../components/validator";
import BackendConfig from "./backendconfig";
import ConfirmationDialog from "../../../../components/confirmationdlg";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import NoresultsOverlay from '../../../../components/noresultsOverlay';
import WarningIcon from '@mui/icons-material/Warning';

const useStyles = makeStyles((theme) => (
    {
        paper: {
            padding: theme.spacing(2),
            backgroundColor: theme.palette.background.paper
        },
        button: {
            marginRight: theme.spacing(1),
        },
        addButton: {
            float: 'right',
        },
        select: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
            width: '100%',
        },
        buttonRight: {
            float: 'right',
        },
        CheckIcon: {
            color: theme.palette.primary.main,
        },
        closedAccordion: {
            display: 'none',
        },
        protocolSelect: {
            width: '100%',
            marginTop: theme.spacing(2),
        },
        ...Animations.Push(theme),
        chips: {
            display: 'flex',
            flexWrap: 'wrap',
            minHeight: 36,
        },
        chip: {
            margin: 2,
            background: theme.palette.secondary.main,
            color: '#FFF',
            fontSize: 16,
            '& .MuiChip-deleteIcon': {
                color: 'rgba(255, 255, 255, 0.75)',
            },
        },
        wizard: {
            minWidth: '251px',
            minHeight: '607px'
        },
        divider: {
            width: '90%', borderWidth: 1, borderColor: 'gray', mx: 'auto'
        },
        tabs: {
            marginTop: 2,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
        tab: {
            marginLeft: 2,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0px 24px 0px 0px',
            gap: '25px',
            background: theme.palette.background.paper,
            transition: 'background-color 0.3s',
        },
        selectedTab: {
            borderRadius: '4px',
            backgroundColor: `${alpha(theme.palette.background.textAlt, 0.5)}`,
            fontWeight: 'bold',
            fontSize: '17px',
            '&:hover': {
                backgroundColor: `${alpha(theme.palette.primary.main, 0.3)}`,
            },
        },
        unselectedTab: {
            backgroundColor: 'transparent',
            color: theme.palette.text.primary,
            fontSize: '17px',
            '&:hover': {
                backgroundColor: `${alpha(theme.palette.primary.main, 0.03)}`,
            },
        },
        CheckIcon: {
            color: theme.palette.primary.main,
        }

    }));

const CreateLoadBalancer = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const loadBalancerForm = useValidate({});
    const gcpPerms = Auth.permissions.get('GCP');
    const routeParams = useParams();
    const location = useLocation();
    const [readonly] = useState(!gcpPerms.write);
    const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(true);
    const steps = ['Backend Configuration ', 'Frontend Configuration', 'overview'];
    const [expanded, setExpanded] = useState(false);
    const [isUpdate, setIsupdate] = useState(false);
    const [selectedBackend, setSelectedBackend] = useState(null);
    const [networkType, setNetworkType] = useState("within");
    const [deleteBackendDialog, setDeleteBackendDialog] = useState(false);
    const [sharedNetworkList, setsharedNetworkList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [backendServices, setBackendServices] = useState({
        backends: [],
        connectionDraining: {
            drainingTimeoutSec: 300
        },
        description: "",
        failoverPolicy: {
            disableConnectionDrainOnFailover: false,
            dropTrafficIfUnhealthy: false,
            failoverRatio: 0
        },
        healthChecks: [],
        loadBalancingScheme: "INTERNAL",
        logConfig: {
            enable: false,
        },
        name: "",
        network: "",
        sharedNetwork: "",
        protocol: "TCP",
        region: "",
        regionName: "",
        networkName: "",
        sharedNetworkName: "",
        selfLink: "",
        sessionAffinity: "NONE"
    });
    const [editingBackend, setEditingBackend] = useState(null);
    const [editingFrontend, setEditingFrontend] = useState(null);
    const [frontendServices, setFrontendServices] = useState([]);
    const [selectedFrontend, setSelectedFrontend] = useState(null);
    const [deleteFrontendDialog, setDeleteFrontendDialog] = useState(false);
    const [instanceGroups, setInstaceGroups] = useState([]);
    const [forwardingRules, setForwardingRules] = useState([]);
    const [project, setProject] = useState(null);
    const [isFailover, setIsFailover] = useState(false);
    const [healthCheckName, setHealthCheckName] = useState(null);
    const [healthChecksList, setHealthChecksList] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [networkList, setNetworkList] = useState([]);
    const [subnetworkList, setSubnetworkList] = useState([]);
    const [validate, setValidate] = useState({
        backendValid: false,
        frontendValid: false,
    });
    const [nameError, setNameError] = useState("");
    const nameReg = new RegExp('^[a-z0-9-]+$');

    const handleCancel = () => {
        navigate("/system/port_mirroring/gcp", { state: { tab: 1 } });
    }

    useEffect(() => {
        const y = forwardingRules.length > 0 ? forwardingRules.filter((rule) => rule.backendService === backendServices.selfLink) : [];
        const w = y.map((rule, index) => ({ ...rule, id: index, ipVersion: rule.ipVersion, subnetworkName: GCPService.selfLinktoName(rule.subnetwork), ports: rule.allPorts, serviceLabel: rule.serviceLabel, modified: false }));
        setFrontendServices(w);
    }, [forwardingRules]);

    useEffect(() => {
        const hasFailover = backendServices.backends.some(backend => backend.failover === true);
        setIsFailover(hasFailover);

        if (isUpdate) {
            const advancedConfigEnabled =
                backendServices.failoverPolicy?.failoverRatio ? backendServices.failoverPolicy.failoverRatio === 0 ||
                    backendServices.failoverPolicy?.dropTrafficIfUnhealthy ? backendServices.failoverPolicy.dropTrafficIfUnhealthy === true : false : false;
            setExpanded(advancedConfigEnabled);

        }

    }, [backendServices]);

    useEffect(() => {

        let backendvalid = false;
        let frontendvalid = false;

        switch (activeStep) {
            case 0:

                backendvalid =
                    (backendServices.name || "").length > 0 &&
                    (backendServices.region || "").length > 0 &&
                    (networkType === "within" ? (backendServices.network || "").length > 0 : (backendServices.sharedNetwork || "").length > 0) &&
                    (backendServices.backends.length > 0) &&
                    (backendServices.healthChecks.length > 0);
                setIsNextButtonDisabled(backendvalid);
                setValidate(prev => ({ ...prev, backendValid: backendvalid }));
                break;

            case 1:
                frontendvalid = frontendServices.length > 0;
                setIsNextButtonDisabled(frontendvalid);
                setValidate(prev => ({ ...prev, frontendValid: frontendvalid }));
                break;
            case 2:
                setIsNextButtonDisabled(validate.backendValid && validate.frontendValid);
        }



    }, [backendServices, backendServices.backends, networkType, frontendServices, activeStep]);

    useEffect(() => {
        const initialize = async () => {
            try {
                const project = await getHost();
                if (routeParams.id) {
                    setIsupdate(true);
                    if (location && location.state && location.state.data) {
                        let a = _cloneDeep(location.state.data);
                        a.regionName = GCPService.selfLinktoName(a.region);

                        if (a.network) {
                            if (project && a.network.includes(project)) {
                                setNetworkType("shared");
                                a.sharedNetwork = a.network;
                                a.sharedNetworkName = GCPService.selfLinktoName(a.network);
                                a.network = "";
                            } else {
                                a.networkName = GCPService.selfLinktoName(a.network);
                            }
                        }

                        a.backends = a.backends.map((v, i) => ({ ...v, groupName: GCPService.selfLinktoName(v.group), id: i + 1 }));
                        fetchForwardingRulesByRegion(a.regionName);
                        setBackendServices({ ...a });
                        setValidate({
                            backendValid: true,
                            frontendValid: true
                        })
                        setHealthCheckName(GCPService.selfLinktoName(a.healthChecks[0]));
                    }
                }
            } catch (error) {
                console.error(`Failed to ${isUpdate ? 'update' : 'create'}: ${error.message}`)
            }
        }

        initialize();
    }, [routeParams]);

    useEffect(() => {
        LoadBalancerService.getHealthChecks().then((res) => {
            setHealthChecksList(res.items);
        });

        if (!isUpdate) {
            fetchData();
            fetchHost();
        }
    }, []);

    useEffect(() => {
        fetchSharedNetworks();
    }, [project]);

    useEffect(() => {
        const gt = async () => {
            const [subnets, networks] = await Promise.all([
                GCPService.getSubnets(backendServices.regionName),
                GCPService.getNetworksMap()
            ]);

            let networkItems = [...networks].map(([networkName, { selfLink, subnetworks }]) => {
                let subnetworkItems = [...subnetworks].map(([subnetworkName, subnetworkSelfLink]) => {
                    let cidr = "";
                    if (subnets.items) {
                        cidr = subnets.items.find(s => s.selfLink === subnetworkSelfLink);
                    }
                    return { 'name': subnetworkName, 'selfLink': subnetworkSelfLink, 'cidr': cidr };
                });

                return { 'name': networkName, 'selfLink': selfLink, 'subnetworks': subnetworkItems };
            });
            setNetworkList(networkItems);
        }
        if (backendServices.regionName !== "") {
            gt();
        }

    }, [backendServices.regionName]);

    const getHost = async () => {
        try {
            const data = await GCPService.getXPNhosts();
            if (data.name) {
                return data.name;
            }
            return null;
        } catch (error) {
            console.error('Error fetching XPN hosts');
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveStep(newValue);
    };

    const fetchForwardingRulesByRegion = async (regionName) => {
        try {
            let res = await LoadBalancerService.getFrontendServicesList(regionName);
            if (res.items) {
                setForwardingRules(res.items)
            } else {
                setForwardingRules([])
            }
        } catch (error) {
            console.error(`Error fetching forwarding rules: ${error.message}`);
        }
    }

    const fetchHost = async () => {
        try {
            const host = await GCPService.getXPNhosts();
            if (host.name) {
                setProject(host.name)
            }
            else {
                throw new Error(host)
            }
        } catch (error) {
            console.error(`Error while fetching XPN hosts: ${error.message}`);
        }
    }

    const fetchData = async () => {
        try {
            const [regions, instancegroups] = await Promise.all([
                GCPService.getRegionsMap(),
                InstanceGroupService.getInstanceGroups()
            ]);

            let groupItems = [];
            for (var [zone, info] of Object.entries(instancegroups.items)) {
                if (info.instanceGroups) {
                    info.instanceGroups.map((instanceGroup) => groupItems.push(instanceGroup));
                }
            }

            setInstaceGroups(groupItems);

            let regionItems = [...regions].map(([regionName, { selfLink, zones }]) => {
                let zoneItems = [...zones].map(([zoneName, zoneSelfLink]) => ({ 'name': zoneName, 'selfLink': zoneSelfLink }));
                return { 'name': regionName, 'selfLink': selfLink, 'zones': zoneItems };
            });

            setRegionList(regionItems);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchSharedNetworks = async () => {
        try {
            if (project) {
                const sharednetworks = await GCPService.getSharedNetwork(project);
                const i = sharednetworks.items.map((network) => ({
                    'name': network.name, 'selfLink': network.selfLink, 'subnetworks': network.subnetworks.map((subnetwork) => ({
                        'name': GCPService.selfLinktoName(subnetwork),
                        'selfLink': subnetwork
                    }))
                }));

                setsharedNetworkList(i)
            }
        } catch (error) {
            console.error(`Error fetching shared networks: ${error.message}`);
        }
    }

    const handleSubmit = async () => {
        setLoading(true);
        setIsNextButtonDisabled(true);
        let a = _cloneDeep(backendServices);
        const regionName = a.regionName;
        a.backends.map((backend) => {
            delete backend.groupName
            delete backend.onCreateUpdate
            delete backend.id
        });
        delete a.regionName;
        delete a.networkName;
        delete a.sharedNetworkName;
        delete a.id;

        if (networkType === "shared") {
            a.network = a.sharedNetwork;
            delete a.sharedNetwork;
        }

        if (isUpdate) {
            try {
                let backendReqBody = { backends: [...a.backends], healthChecks: a.healthChecks };
                if (a.failoverPolicy) {
                    backendReqBody.backends = backendReqBody.backends.map(backend => {
                        return { ...backend, failover: a.failoverPolicy };
                    });
                }

                await LoadBalancerService.patchBackendService(regionName, a.name, backendReqBody);
                var backendServiceLink = "";

                await LoadBalancerService.getRegionBackend(regionName, a.name).then((res) => {
                    backendServiceLink = res.selfLink;
                });

                let b = _cloneDeep(frontendServices);
                for (var i = 0; i < b.length; i++) {
                    delete b[i].id;
                    delete b[i].subnetworkName;
                    if (b[i].modified) {
                        if (b[i]?.create) {
                            b[i].region = a.region;
                            b[i].backendService = backendServiceLink;
                            try {
                                await LoadBalancerService.createForwardingRule(regionName, b[i]);
                            } catch (error) {
                                throw new Error('Failed to create forwarding rule');
                            }
                        } else {
                            const updatedRule = {
                                allowGlobalAccess: b[i].allowGlobalAccess ? b[i].allowGlobalAccess : false,
                                fingerprint: b[i].fingerprint
                            };

                            await LoadBalancerService.patchForwardingRule(regionName, b[i].name, updatedRule);
                        }
                    }
                }
                setLoading(false);
                toast.success("Loadbalancer updated successfully")
                navigate("/system/port_mirroring/gcp", { state: { tab: 1 } });
            } catch (error) {
                console.error("Error updating loadbalancer:", error.message);
                toast.error(`Failed to update loadbalancer: ${error.message}`);
                handleCancel();
            }
        } else {
            try {
                await LoadBalancerService.createRegionBackend(regionName, a);

                var backendServiceLink = "";
                await LoadBalancerService.getRegionBackend(regionName, a.name).then((res) => {
                    backendServiceLink = res.selfLink;
                });

                setTimeout(async () => {
                    if (backendServiceLink !== "") {
                        let c = _cloneDeep(frontendServices);
                        for (var i = 0; i < c.length; i++) {
                            delete c[i].id;
                            delete c[i].subnetworkName;
                            c[i].region = a.region;
                            c[i].backendService = backendServiceLink;
                            try {
                                await LoadBalancerService.createForwardingRule(regionName, c[i]);
                            } catch (error) {
                                console.error('error in creating frontend rule: ', error);
                                toast.error(`Failed to create frontend rule: ${error.message}`);
                                navigate("/system/port_mirroring/gcp", { state: { tab: 1 } });
                                handleCancel();
                                return;
                            }
                        }
                        setLoading(false);
                        toast.success("Loadbalancer created successfully")
                        navigate("/system/port_mirroring/gcp", { state: { tab: 1 } });
                    }
                }, 10000);
            } catch (error) {
                console.error("Error creating loadbalancer:", error);
                toast.error(`Failed to create loadbalancer: ${error.message}`);
                handleCancel()
            }
        }
    }

    const handleNext = () => {
        if (activeStep === steps.length - 1) {
            handleSubmit();
        }
        else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleSelectBackend = (s) => {
        setSelectedBackend(s.row);
    };

    const handleSelectFrontend = (s) => {
        setSelectedFrontend(s.row);
    };

    const handleOpenDeleteBackend = (e) => {
        setDeleteBackendDialog(true);
    };

    const handleOpenDeleteFrontend = (e) => {
        setDeleteFrontendDialog(true);
    };

    const handleCloseDeleteBackend = () => {
        setDeleteBackendDialog(false);
    };

    const handleCloseDeleteFrontend = () => {
        setDeleteFrontendDialog(false);
    };

    const handleStepClick = (stepIndex) => {
        if (stepIndex >= 0 && stepIndex < steps.length) {
            setActiveStep(stepIndex);
        }
    };

    const handleLoadBalancerName = (e, validID, valid) => {
        const newName = e.target.value;

        if (!nameReg.test(newName)) {
            setNameError("Enter lowercases, numbers, and hypens");
        } else {
            setNameError("");
        }
        console.log(e.target.name);
        loadBalancerForm.set({ ...loadBalancerForm.get(), [validID]: valid });
        setBackendServices({
            ...backendServices,

            [e.target.name]: e.target.value,
        });
    };

    const handleLoadBalancerChange = (e, validID, valid) => {
        loadBalancerForm.set({ ...loadBalancerForm.get(), [validID]: valid });
        setBackendServices({
            ...backendServices,

            [e.target.name]: e.target.value,
        });
    };


    const handleAutocompletechange = (event, newValue, field) => {
        if (field === "network" || field === "sharedNetwork") {

        }

        if (newValue) {
            var fieldName = field + 'Name';
            loadBalancerForm.set({ ...loadBalancerForm.get(), [field]: newValue.selfLink });
            setBackendServices((prevData) => ({
                ...prevData,
                [fieldName]: newValue.name,
                [field]: newValue.selfLink,
            }));

        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleEnableDropTraffic = (event) => {
        const isChecked = event.target.checked;
        setBackendServices(prevState => ({
            ...prevState,
            failoverPolicy: {
                ...prevState.failoverPolicy,
                dropTrafficIfUnhealthy: isChecked
            }
        }));
    };
    const handleEnableConnectionDraning = (event) => {
        const isChecked = event.target.checked;
        setBackendServices(prevState => ({
            ...prevState,
            failoverPolicy: {
                ...prevState.failoverPolicy,
                disableConnectionDrainOnFailover: isChecked
            }
        }));
    };

    const handleHealthAutocompleteChange = (event, newValue, field) => {

        if (newValue) {
            setBackendServices((prevState) => ({
                ...prevState,
                healthChecks: [newValue.selfLink],
            }));
            setHealthCheckName(newValue.name);
        }
    };

    const handleUpdatefailoverRatio = (e) => {
        const newValue = e.target.value.trim();
        setBackendServices((prevBackendServices) => ({
            ...prevBackendServices,
            failoverPolicy: {
                ...prevBackendServices.failoverPolicy,
                failoverRatio: newValue === "" ? "" : parseInt(newValue),
            },
        }));
    };

    const handleProtocolChange = (event) => {
        const { value } = event.target;
        setBackendServices((prevState) => ({
            ...prevState,
            protocol: value,
        }));
    };

    const handleDrainTimeoutChange = (e, validID, valid) => {
        const newValue = e.target.type === 'number' ? parseInt(e.target.value) : e.target.value;

        if (valid) {
            setBackendServices((prevState) => ({
                ...prevState,
                connectionDraining: {
                    ...prevState.connectionDraining,
                    drainingTimeoutSec: newValue
                }
            }));
        }

        if (!valid) {
            console.error('Invalid input:', validID);
        }
    };

    const handleToggle = () => {
        setExpanded(!expanded);
    };

    const addBackend = (backend) => {
        let duplicateBackends = backendServices.backends.filter((item) => item.groupName === backend.groupName);
        if (duplicateBackends.length > 0) {
            toast.error("select different instance groups");
        } else {
            delete backend.failoverPolicy;
            setBackendServices((prevState) => ({
                ...prevState,
                backends: [...prevState.backends, { ...backend, id: Date.now() }]
            }));
            setSelectedBackend(null);
        }
    };

    const addFrontend = (frontend) => {
        setFrontendServices((prevState) => [
            ...prevState,
            { ...frontend, id: Date.now() }
        ]);
        setSelectedFrontend(null);
    };

    const onCloseBackend = () => {
        setEditingBackend(null);
        setSelectedBackend(null);
    }

    const onCloseFrontend = () => {
        setEditingFrontend(null);
        setSelectedFrontend(null);
    }

    const updateBackend = (updatedBackend) => {
        let y = updatedBackend.failoverPolicy;
        delete updatedBackend.failoverPolicy;
        delete updatedBackend.onCreateUpdate;
        setBackendServices((prevState) => ({
            ...prevState,
            failoverPolicy: y,
            backends: prevState.backends.map((backend) =>
                backend.id === updatedBackend.id ? updatedBackend : backend

            )
        }));
        setSelectedBackend(null);
        setEditingBackend(null);
    };

    const updateFrontend = (updatedFrontend) => {
        setFrontendServices((prevState) =>
            prevState.map((frontend) =>
                frontend.id === updatedFrontend.id ? updatedFrontend : frontend
            )
        );
        setEditingFrontend(null);
        setSelectedFrontend(null);
    };

    const handleDeleteBackend = () => {
        const updatedBackends = backendServices.backends.filter(
            (backend) => backend.id !== selectedBackend.id
        );

        setBackendServices({
            ...backendServices,
            backends: updatedBackends
        });

        setDeleteBackendDialog(false);
        setSelectedBackend(null);
    };

    const handleNetworkTypeChange = (event) => {
        if (!isUpdate) {
            setNetworkType(event.target.value);
        }
    }

    const handleDeleteFrontend = () => {

        const updatedFrontends = frontendServices.filter(
            (frontend) => frontend.id !== selectedFrontend.id
        );

        setFrontendServices(updatedFrontends);
        setDeleteFrontendDialog(false);
        setSelectedFrontend(null);
    };

    const handleEditBackend = () => {
        setEditingBackend(selectedBackend)
    };

    const handleEditFrontend = () => {
        setEditingFrontend(selectedFrontend)
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };


    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper>
                    <Box p={5}>
                        <Grid item container xs={12} >
                            <Grid item xs={12} display="flex" direction='column'    >
                                <Box>
                                    <Typography variant="h6">
                                        {readonly
                                            ? "View Load Balancer"
                                            : (isUpdate
                                                ? 'Update Load Balancer'
                                                : 'Create Load Balancer')}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item container xs={12} spacing={2}>
                                <Grid item xs={6} mt={4} >
                                    <FormControl fullWidth>
                                        <TextField
                                            disabled={readonly || isUpdate}
                                            label="Name"
                                            name="name"
                                            value={backendServices.name || ""}
                                            onChange={(e, validID, valid) => {
                                                handleLoadBalancerName(e, validID, valid);
                                            }}
                                            error={nameError !== ""}
                                            helperText={`${nameError}`}
                                        ></TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} mt={4}>
                                    <Autocomplete
                                        disabled={readonly || isUpdate}
                                        value={backendServices.regionName}
                                        onChange={(event, newValue) =>
                                            handleAutocompletechange(
                                                event,
                                                newValue
                                                    ? typeof newValue === "object"
                                                        ? newValue : null
                                                    : null,
                                                "region"
                                            )
                                        }
                                        options={regionList}
                                        isOptionEqualToValue={(option, value) => option.name === value}
                                        getOptionLabel={(option) =>
                                            typeof option === "object"
                                                ? `${option.name}`
                                                : option
                                        }
                                        renderInput={(params) => (
                                            <TextField {...params} label="Region" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item container xs={12} spacing={2}>
                                <Grid item container xs={12} >
                                    <Grid item xs={12}>
                                        <FormControl component="fieldset" margin="normal">
                                            <RadioGroup row value={networkType} onChange={handleNetworkTypeChange}>
                                                <FormControlLabel value="within" control={<Radio />} label={"Networks in this project"} />
                                                <FormControlLabel value="shared" control={<Radio />} label={`Networks shared with me (from host project: '${project}')`} />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>

                                    {networkType === "within" && (
                                        <Grid item xs={6}>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    disabled={readonly || isUpdate}
                                                    value={backendServices.networkName}
                                                    options={networkList}
                                                    onChange={
                                                        (event, newValue) => handleAutocompletechange(event, newValue ? typeof newValue === "object" ? newValue : null : null, "network")
                                                    }
                                                    getOptionLabel={(option) => typeof option === 'object' ? `${option.name}` : option}
                                                    renderInput={(params) => <TextField {...params} label="Network" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )}

                                    {networkType === "shared" && (
                                        <Grid item xs={6}>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    disabled={readonly || isUpdate}
                                                    value={backendServices.sharedNetworkName}
                                                    options={sharedNetworkList}
                                                    onChange={
                                                        (event, newValue) => handleAutocompletechange(event, newValue ? typeof newValue === "object" ? newValue : null : null, "sharedNetwork")
                                                    }
                                                    getOptionLabel={(option) => typeof option === 'object' ? `${option.name}` : option}
                                                    renderInput={(params) => <TextField {...params} label="Shared Network" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Grid>

            <Grid item xs={2.5} >
                <Paper className={classes.paper} sx={{ height: '100%' }}>
                    <Grid container={2} >
                        <Tabs
                            orientation="vertical"
                            value={activeStep}
                            onChange={handleTabChange}
                            indicatorColor="primary"
                            className={classes.tabs}
                        >
                            <Tab
                                label="Backend Configuration"
                                icon={validate.backendValid ? <CheckCircleRoundedIcon className={classes.CheckIcon} /> : ''}
                                iconPosition="end"
                                className={`${classes.tab} ${activeStep === 0 ? classes.selectedTab : classes.unselectedTab}`}
                            />
                            <Tab
                                label="Frontend Configuration"
                                icon={validate.frontendValid ? <CheckCircleRoundedIcon className={classes.CheckIcon} /> : ''}
                                iconPosition="end"
                                className={`${classes.tab} ${activeStep === 1 ? classes.selectedTab : classes.unselectedTab}`}
                            />
                            <Tab
                                label="Review"
                                className={`${classes.tab} ${activeStep === 2 ? classes.selectedTab : classes.unselectedTab}`}
                            />
                        </Tabs>
                    </Grid>
                </Paper>
            </Grid >
            <Grid item xs={9.5}>

                <Paper>
                    <Box p={5}>
                        {activeStep === 0 && (
                            <Grid item container xs={12} spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h6">Backend Configuration</Typography>
                                </Grid>
                                <Grid item xs={6} >
                                    <Validator
                                        disabled={true}
                                        multiple
                                        errorText="Name cannot be empty"
                                        fullWidth
                                        label="Name"
                                        name="name"
                                        value={backendServices.name || ""}
                                        onChange={(e, validID, valid) => {
                                            handleLoadBalancerChange(e, validID, valid);
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={6} >
                                    <FormControl fullWidth variant="outlined" >
                                        <InputLabel id="protocol-select-label">Protocol</InputLabel>
                                        <Select
                                            disabled={readonly || isUpdate}
                                            labelId="protocol-select-label"
                                            id="protocol-select"
                                            value={backendServices.protocol}
                                            onChange={handleProtocolChange}
                                            label="Protocol"
                                        >
                                            <MenuItem value="TCP">TCP</MenuItem>
                                            <MenuItem value="UDP">UDP</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <Autocomplete
                                        value={healthCheckName}
                                        fullWidth
                                        onChange={(event, newValue) =>
                                            handleHealthAutocompleteChange(
                                                event,
                                                newValue ? typeof newValue == 'object' ? newValue : null : null,
                                                "Health checks"
                                            )
                                        }
                                        options={healthChecksList}
                                        isOptionEqualToValue={(option, value) => option.name === value}
                                        getOptionLabel={(option) =>
                                            typeof option === "object"
                                                ? `${option.name}`
                                                : option
                                        }
                                        renderInput={(params) => (
                                            <TextField {...params} label="Health checks" />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Validator
                                        disabled={readonly}
                                        valueType="range"
                                        errorText="Cannot be empty"
                                        fullWidth
                                        type="number"
                                        inputProps={{
                                            min: 1,
                                            max: 2147483647,
                                        }}
                                        label="Connection draining timeout (seconds)"
                                        name="drainingTimeoutSec"
                                        value={backendServices.connectionDraining.drainingTimeoutSec}
                                        onChange={(e, validID, valid) => {
                                            handleDrainTimeoutChange(e, validID, valid);
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} mt={4}>
                                    <BackendConfig
                                        addBackend={addBackend}
                                        updateBackend={updateBackend}
                                        editingBackend={editingBackend}
                                        instanceGroups={instanceGroups}
                                        region={backendServices.regionName}
                                        backendsList={backendServices.backends}
                                        onClose={onCloseBackend}
                                        isUpdate={isUpdate}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid item xs={12} >
                                        <Typography variant="h6">Failover Policy</Typography>
                                    </Grid>
                                    <Grid item xs={12} mt={2} >
                                        <Box display="flex" flexWrap="wrap" alignItems="center" spacing={2} className={classes.paper}>
                                            <WarningIcon color="secondary" sx={{ mr: 2 }} />
                                            <Typography variant="subtitle1">
                                                For failover capability, one backend marked as failover
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    {isFailover && (
                                        <Grid item container xs={12} mt={2} >
                                            <Grid item xs={6}>
                                                <Validator
                                                    valueType="range"
                                                    errorText="sample rate must be within 0 and 1"
                                                    fullWidth
                                                    label="Failover Ratio"
                                                    allowEmpty
                                                    type="decimal"
                                                    inputProps={{
                                                        min: 0,
                                                        max: 1,
                                                    }}
                                                    name="failoverRatio"
                                                    value={
                                                        backendServices.failoverPolicy?.failoverRatio ? backendServices.failoverPolicy.failoverRatio == 0
                                                            ? 0
                                                            : backendServices.failoverPolicy.failoverRatio : 0
                                                    }
                                                    onChange={handleUpdatefailoverRatio}
                                                    disabled={readonly}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControlLabel margin="normal"
                                                    control={
                                                        <Checkbox
                                                            checked={backendServices.failoverPolicy?.dropTrafficIfUnhealthy ? backendServices.failoverPolicy.dropTrafficIfUnhealthy : false}
                                                            onChange={handleEnableDropTraffic}
                                                            name="myCheckbox"
                                                        />
                                                    }
                                                    label="Enable (Drop new connections if no healthy VMs)"
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControlLabel margin="normal"
                                                    control={
                                                        <Checkbox
                                                            checked={backendServices.failoverPolicy?.disableConnectionDrainOnFailover ? backendServices.failoverPolicy.disableConnectionDrainOnFailover : false}
                                                            onChange={handleEnableConnectionDraning}
                                                            name="myCheckbox"
                                                        />
                                                    }
                                                    label="Enable connection draining on failover"
                                                />
                                            </Grid>
                                        </Grid>

                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <Box className={classes.fullWidth} height={400} mt={2}>
                                        <DataGridPro
                                            components={{
                                                Header: readonly ? undefined : () => {
                                                    return (
                                                        <Box display="flex" width="100%" justifyContent="flex-end">
                                                            <IconButton
                                                                variant="contained"
                                                                color="primary"
                                                                aria-label="edit backend"
                                                                onClick={handleEditBackend}
                                                                disabled={!selectedBackend}
                                                                size="large">
                                                                <EditIcon />
                                                            </IconButton>
                                                            <IconButton
                                                                variant="contained"
                                                                color="secondary"
                                                                aria-label="delete backend"
                                                                onClick={handleOpenDeleteBackend}
                                                                disabled={!selectedBackend}
                                                                size="large">
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Box>
                                                    );
                                                },
                                                NoRowsOverlay: () => <NoresultsOverlay message="Create a Backend Configuration for the Network Load Balance to act as the packet mirroring collector. " />,
                                            }}
                                            getRowId={(r) => r.id}
                                            rows={backendServices.backends}
                                            columns={[
                                                { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Instance group', field: 'groupName', renderCell: d => { return <div>{d.row.groupName}</div> } },
                                                { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'IP Stack Type', field: 'ipStackType ', renderCell: d => { return <div>{d.row.stackType === 'dual' ? 'IPv4 and IPv6 (dual-stack)' : 'IPv4 (single)'}</div> } },
                                                { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Failover', field: 'failover', renderCell: d => { return <div>{d.row.failover ? "Yes" : "No"}</div> } },
                                            ]}
                                            disableMultipleSelection
                                            onRowClick={handleSelectBackend}
                                        />
                                    </Box>

                                    <ConfirmationDialog
                                        onClose={handleCloseDeleteBackend}
                                        onOK={handleDeleteBackend}
                                        open={deleteBackendDialog}
                                        message={`Are you sure you want to remove the Backend ${selectedBackend && selectedBackend.id}?`}
                                        title="Delete Backend"
                                        cancelLabel="Cancel"
                                        okLabel="Yes"
                                    />

                                </Grid>
                            </Grid>
                        )}

                        {activeStep === 1 && (
                            <Grid item container xs={12} spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h6">Frontend Configuration</Typography>
                                </Grid>
                                <Grid item xs={12} mt={2}>
                                    <FrontendConfig
                                        frontends={frontendServices}
                                        addFrontend={addFrontend}
                                        updateFrontend={updateFrontend}
                                        editingFrontend={editingFrontend}
                                        protocol={backendServices.protocol}
                                        region={backendServices.regionName}
                                        networkLink={networkType === "within" ? backendServices.network : backendServices.sharedNetwork}
                                        networks={networkType === "within" ? networkList : sharedNetworkList}
                                        onClose={onCloseFrontend}
                                        isUpdate={isUpdate}
                                        networkType={networkType}
                                        project={project}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Box className={classes.fullWidth} height={400} mt={2}>
                                        <DataGridPro
                                            components={{
                                                Header: readonly ? undefined : () => {
                                                    return (
                                                        <Box display="flex" width="100%" justifyContent="flex-end">
                                                            <IconButton
                                                                variant="contained"
                                                                color="primary"
                                                                aria-label="edit frontend"
                                                                onClick={handleEditFrontend}
                                                                disabled={!selectedFrontend}
                                                                size="large">
                                                                <EditIcon />
                                                            </IconButton>
                                                            <IconButton
                                                                variant="contained"
                                                                color="secondary"
                                                                aria-label="delete frontend"
                                                                onClick={handleOpenDeleteFrontend}
                                                                disabled={!selectedFrontend}
                                                                size="large">
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Box>
                                                    );
                                                },
                                                NoRowsOverlay: () => <NoresultsOverlay message="Create a Frontend Network Load Balance configuration to act as the packet mirroring collector." />,
                                            }}
                                            rows={frontendServices}
                                            getRowId={(r) => r.id}
                                            columns={[
                                                { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Protocol', field: 'IPProtocol', renderCell: d => { return <div>{d.row.IPProtocol}</div> } },
                                                { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Ip version', field: 'ipVersion', renderCell: d => { return <div>{d.row.ipVersion}</div> } },
                                                { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Subnetwork', field: 'subnetworkName', renderCell: d => { return <div>{d.row.subnetworkName}</div> } },
                                                { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'IP: Ports', field: 'ports', renderCell: d => { return <div>{`${d.row.IPAddress === undefined ? "AUTOMATIC" : d.row.IPAddress} : ${d.row.allPorts ? 'All' : ''}`}</div> } },
                                                //{ sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Service Label', field: 'serviceLabel', renderCell: d => { return <div>{d.row.serviceLabel}</div> } },
                                            ]}
                                            disableMultipleSelection
                                            onRowClick={handleSelectFrontend}
                                        />
                                    </Box>

                                    <ConfirmationDialog
                                        onClose={handleCloseDeleteFrontend}
                                        onOK={handleDeleteFrontend}
                                        open={deleteFrontendDialog}
                                        message={`Are you sure you want to remove the Frontend ${selectedFrontend && selectedFrontend.id}?`}
                                        title="Delete Frontend"
                                        cancelLabel="Cancel"
                                        okLabel="Yes"
                                    />
                                </Grid>
                            </Grid>
                        )
                        }
                        {
                            activeStep === 2 && (
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6">Summary</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h7">Backend</Typography>
                                    </Grid>
                                    <Grid container item xs={6} justifyContent="space-between">
                                        <Grid item>
                                            <Typography variant="subtitle1">Region</Typography>
                                            <Typography variant="body1">
                                                {backendServices?.regionName || "--"}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1">Network</Typography>
                                            <Typography variant="body1">
                                                {backendServices?.networkName || "--"}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1">Protocol</Typography>
                                            <Typography variant="body1">
                                                {backendServices?.protocol || "--"}
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Box className={classes.fullWidth} height={400}>
                                            <DataGridPro
                                                components={{
                                                    NoRowsOverlay: () => <NoresultsOverlay message="Create a Backend Configuration for the Network Load Balancer to act as the packet mirroring collector. " />,
                                                }}
                                                getRowId={(r) => r.id}
                                                rows={backendServices.backends}
                                                columns={[
                                                    { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Instance group', field: 'groupName', renderCell: d => { return <div>{d.row.groupName}</div> } },
                                                    { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Type', renderCell: d => { return <div>Instance</div> } },
                                                    { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Failover', field: 'failover', renderCell: d => { return <div>{d.row.failover ? "Yes" : "No"}</div> } },
                                                ]}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h7">Frontend</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box className={classes.fullWidth} height={400}>
                                            <DataGridPro
                                                components={{
                                                    NoRowsOverlay: () => <NoresultsOverlay message="Create a Frontend Network Load Balance configuration to act as the packet mirroring collector." />,
                                                }}
                                                rows={frontendServices}
                                                getRowId={(r) => r.id}
                                                columns={[
                                                    { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Protocol', field: 'IPProtocol', renderCell: d => { return <div>{d.row.IPProtocol}</div> } },
                                                    { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Ip version', field: 'ipVersion', renderCell: d => { return <div>{d.row.ipVersion}</div> } },
                                                    { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'Subnetwork', field: 'subnetworkName', renderCell: d => { return <div>{d.row.subnetworkName}</div> } },
                                                    { sortable: true, flex: 1, type: 'string', disableColumnMenu: true, hidden: false, headerName: 'IP: Ports', field: 'ports', renderCell: d => { return <div>{`${d.row.IPAddress === undefined ? "AUTOMATIC" : d.row.IPAddress} : ${d.row.allPorts ? 'All' : ''}`}</div> } },
                                                ]}
                                            />
                                        </Box>

                                    </Grid>
                                </Grid>
                            )
                        }
                    </Box>
                </Paper>
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, pb: 6 }}>
                    {activeStep !== 0 && (
                        <Button
                            variant="contained"
                            color="secondary"
                            disabled={activeStep === 0 || loading}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            Back
                        </Button>
                    )}
                    <Box sx={{ flex: '1 1 auto', justifyContent: "space-between" }} />
                    <Button
                        onClick={handleCancel}
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        disabled={loading}
                    >
                        Cancel
                    </Button>

                    <Button
                        // disabled
                        onClick={handleNext}
                        variant="contained"
                        color="primary"
                        disabled={!isNextButtonDisabled || loading}
                    >
                        {activeStep === steps.length - 1 && isUpdate ? 'Update' : activeStep === steps.length - 1 ? 'Save' : 'Next'}
                    </Button>
                </Box>
            </Grid>

        </Grid>

    );
};

export default CreateLoadBalancer